import JoinFullIcon from "@mui/icons-material/JoinFull";
import JoinRightIcon from "@mui/icons-material/JoinRight";
import { Chip, Stack, SvgIcon, Tooltip, Typography } from "@mui/material";
import { ChallengeAnswer } from "../directus/collections";

const ANSWER_ACCEPTANCE_SVG_ICON = {
  is_included: JoinRightIcon,
  exact_match: JoinFullIcon,
};

const ANSWER_ACCEPTANCE_ICON = {
  is_included: (
    <Tooltip title="Il messaggio contiene la parola">
      <SvgIcon component={ANSWER_ACCEPTANCE_SVG_ICON.is_included}></SvgIcon>
    </Tooltip>
  ),
  exact_match: (
    <Tooltip title="La risposta equivale a una di quelle definite">
      <SvgIcon component={ANSWER_ACCEPTANCE_SVG_ICON.exact_match}></SvgIcon>
    </Tooltip>
  ),
};

export function EnigmaAcceptedAnswersBox({
  answers,
  matchType,
  label,
}: {
  answers: ChallengeAnswer[];
  matchType: "is_included" | "exact_match";
  label: string;
}) {
  return (
    <Stack spacing={2}>
      <Stack direction="row" justifyContent={"space-between"}>
        <Typography variant="caption" fontWeight={"bold"} gutterBottom>
          {label}
        </Typography>
        {ANSWER_ACCEPTANCE_ICON[matchType]}
      </Stack>
      <Stack direction={"row"} spacing={1} flexWrap={"wrap"} rowGap={1}>
        {answers.map((answer, i) => (
          <Chip key={i} size="small" label={answer.value} />
        )) ?? "Nessuna risposta accettata disponibile"}
      </Stack>
    </Stack>
  );
}
